import classNames from "classnames/bind";
import { Dispatch, SetStateAction, useState, DetailedHTMLProps, InputHTMLAttributes } from "react";

import styles from "./TextInput.module.scss";
import { SvgViewBlack, SvgHide, SvgRoundCancel } from "assets/svg/Icon";
import { ViewPwIcon, NoViewPwIcon } from "assets";

const cn = classNames.bind(styles);

export interface TextInputProps {
  attribute?: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
  isPassword?: boolean;
  isValidInput?: boolean;
  isValidSubmit?: boolean;
  isDisabled?: boolean;
}

export const TextInput = ({
  attribute,
  isPassword = false,
  isValidInput = true,
  isValidSubmit = true,
  isDisabled = false,
}: TextInputProps) => {
  const [isPasswordViewOn, setIsPasswordViewOn] = useState(false);

  const handleTogglePasswordView = () => {
    setIsPasswordViewOn((prevState) => !prevState);
  };

  return (
    <div className={cn("wrapper-input")}>
      <input
        className={cn("input", {
          "invalid-input": !isValidInput,
          "invalid-submit": !isValidSubmit,
          disable: isDisabled,
        })}
        disabled={isDisabled}
        type={!isPassword ? "text" : isPasswordViewOn ? "text" : "password"}
        {...attribute}
      />
      {!isDisabled &&
        isPassword &&
        (isPasswordViewOn ? (
          <ViewPwIcon className={cn("svg")} onClick={handleTogglePasswordView} />
        ) : (
          <NoViewPwIcon className={cn("svg")} onClick={handleTogglePasswordView} />
        ))}
    </div>
  );
};
